import SlimSelect from 'slim-select';
import noUiSlider from 'nouislider';
import MicroModal from 'micromodal';
import naja from 'naja';

export default class Form {

    static init() {
        naja.initialize.bind(naja);
        Form.handleSlimSelect();
        Form.handleSortSelect();
        Form.validation();
        Form.sliderDesktop();
        Form.sliderMobile();
        Form.handleAddToBasket();
        Form.handleNewPasswordSetting();
        Form.submitOrder();
        Form.handleRedirectSelect();
        Form.handleOrderPerson();
    }

    static submitOrder() {
        const dumpBtn = document.getElementById('submitOrder');
        const realBtn = document.querySelector('[data-form-trigger]');
        const click_timeout = 7.5; // seconds

        let clicked = false;

        if (dumpBtn && realBtn) {
            dumpBtn.addEventListener('click', e => {
                e.preventDefault();
                if (!clicked) {
                    realBtn.click();

                    clicked = true;
                    setTimeout(() => {clicked = false;}, click_timeout * 1000);
                }
            });

            realBtn.addEventListener('click', e => {
                if (clicked) {
                    e.preventDefault();
                } else {
                    clicked = true;
                    setTimeout(() => {clicked = false;}, click_timeout * 1000);
                }
            });
        }
    }

    static handleSlimSelect() {
        // this el exists on category page
        const productBrandEl = document.getElementById('jsProductBrand');
        // this three elements exist on HP and category page
        const productSeriesEl = document.getElementById('jsProductSeries');
        const productSeriesEl2 = document.getElementById('jsProductSeries2');
        const productPrinterEl = document.getElementById('jsProductPrinter');
        // phone prefix (cart - third step with contact information)
        const phonePrefixEl = document.getElementById('jsPhonePrefix');
        const phonePrefixEl2 = document.getElementById('jsPhonePrefix2');

        if (productBrandEl) {
            const productBrand = new SlimSelect({
                select: '#jsProductBrand',
                searchPlaceholder: 'Vyhledávání',
                showContent: 'down',
                valuesUseText: false, // Use text instead of innerHTML for selected values - default false
                data: [
                    {
                        innerHTML: '<div class="flex flex-ai-c"><img height="12" width="auto" src="/img/data/product-grid/canon.png" class="m-r-5"/> Canon</div>',
                        text: 'Image',
                        value: 'canon'
                    },
                    {
                        innerHTML: '<div class="flex flex-ai-c"><img height="26" width="auto" src="/img/data/product-grid/konica-minolta.png" class="m-r-5"/> Konica Minolta</div>',
                        text: 'Image',
                        value: 'konicaMinolta'
                    },
                    {
                        innerHTML: '<div class="flex flex-ai-c"><img height="12" width="auto" src="/img/data/product-grid/epson.png" class="m-r-5"/> Epson</div>',
                        text: 'Image',
                        value: 'epson'
                    },
                    {
                        innerHTML: '<div class="flex flex-ai-c"><img height="12" width="auto" src="/img/data/product-grid/samsung.png" class="m-r-5"/> Samsung</div>',
                        text: 'Image',
                        value: 'samsung'
                    },
                    {
                        innerHTML: '<div class="flex flex-ai-c"><img height="22" width="auto" src="/img/data/product-grid/hp.png" class="m-r-5"/> HP</div>',
                        text: 'Image',
                        value: 'hp'
                    },
                ]
            });
        }

        if (phonePrefixEl) {
            const phonePrefixElVal = phonePrefixEl.value;

            let phonePrefixFlags = [
                {
                    innerHTML: '<div class="flex flex-ai-c m-r-10"><img width="30" src="/img/icons/flags/cs.png" class="m-r-5"/> +420</div>',
                    text: 'Image',
                    value: '+420',
                    selected: '+420' === phonePrefixElVal
                },
                {
                    innerHTML: '<div class="flex flex-ai-c m-r-10"><img width="30" src="/img/icons/flags/sk.png" class="m-r-5"/> +421</div>',
                    text: 'Image',
                    value: '+421',
                    selected: '+421' === phonePrefixElVal
                },
            ];

            const phonePrefix = new SlimSelect({
                select: '#jsPhonePrefix',
                showContent: 'down',
                valuesUseText: false, // Use text instead of innerHTML for selected values - default false
                data: phonePrefixFlags
            });
        }

        if (phonePrefixEl2) {
            const phonePrefixElVal2 = phonePrefixEl2.value;

            let phonePrefixFlags2 = [
                {
                    innerHTML: '<div class="flex flex-ai-c m-r-10"><img width="30" src="/img/icons/flags/cs.png" class="m-r-5"/> +420</div>',
                    text: 'Image',
                    value: '+420',
                    selected: '+420' === phonePrefixElVal2
                },
                {
                    innerHTML: '<div class="flex flex-ai-c m-r-10"><img width="30" src="/img/icons/flags/sk.png" class="m-r-5"/> +421</div>',
                    text: 'Image',
                    value: '+421',
                    selected: '+421' === phonePrefixElVal2
                },
            ];

            const phonePrefix2 = new SlimSelect({
                select: '#jsPhonePrefix2',
                showContent: 'down',
                valuesUseText: false, // Use text instead of innerHTML for selected values - default false
                data: phonePrefixFlags2
            });
        }

        if (productSeriesEl) {
            const productSeries = new SlimSelect({
                select: '#jsProductSeries',
                searchPlaceholder: 'Vyhledávání',
                showContent: 'down'
            });
        }

        if (productSeriesEl2) {
            const productSeries2 = new SlimSelect({
                select: '#jsProductSeries2',
                searchPlaceholder: 'Vyhledávání',
                showContent: 'down'
            });
        }

        if (productPrinterEl) {
            const productPrinter = new SlimSelect({
                select: '#jsProductPrinter',
                searchPlaceholder: 'Vyhledávání',
                showContent: 'down'
            });
        }


    }

    static handleSortSelect() {
        // category page
        const sortEl = document.querySelector('.js-sort-select');

        if (sortEl) {
            if (window.sort) {
                window.sort.destroy();
            }
            window.sort = new SlimSelect({
                select: '.js-sort-select',
                showContent: 'down',
                showSearch: false,
            });

            sortEl.addEventListener('change', function (e) {
                naja.makeRequest('GET', sortEl.value)
            });


        }
    }

    static validation() {
        const formsToValidate = document.querySelectorAll('[data-validation]');

        if (formsToValidate.length > 0) {
            formsToValidate.forEach(form => {
                if (form.dataset.validation === 'onInit') {
                    Form.validateForm(form);
                }

                let requiredControls = form.querySelectorAll('[data-required]');
                requiredControls.forEach(control => {
                    Form.listenControl(control);
                });
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    Form.validateForm(form);
                    const errors = document.querySelectorAll('.form-container--error');
                    if (errors.length === 0) {
                        form.submit();
                    }
                });
            });
        }
    }

    static validateForm(form) {
        let requiredControls = form.querySelectorAll('[data-required]');
        if (requiredControls.length > 0) {
            requiredControls.forEach(control => {
                Form.validateControl(control);
            });
        }
    }

    static validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static validateControl(control) {
        let parent = control.closest('.form-container');
        let isEmail = control.dataset.required === 'email';
        let isCheckbox = control.type === 'checkbox';
        let isNumChar = control.dataset.required === 'numLetter';
        let isPostCode = control.dataset.required === 'postCode';
        let isTel = control.dataset.required === 'tel';

        if (isCheckbox) {
            if (control.checked) {
                parent.classList.remove('form-container--error');
                parent.classList.add('form-container--success');
            } else {
                parent.classList.add('form-container--error');
                parent.classList.remove('form-container--success');
            }
        } else {
            if (control.value === '') {
                parent.classList.add('form-container--error');
                parent.classList.remove('form-container--success');
            } else {
                if (isEmail) {
                    if (this.validateEmail(control.value)) {
                        parent.classList.remove('form-container--error');
                        parent.classList.add('form-container--success');
                    } else {
                        parent.classList.add('form-container--error');
                        parent.classList.remove('form-container--success');
                    }
                } else if (isNumChar) {
                    if ((/(?=.*?[0-9])(?=.*?[A-Za-z])(?=.*[^0-9A-Za-z]).+/g).test(control.value)) {
                        parent.classList.remove('form-container--error');
                        parent.classList.add('form-container--success');
                    } else {
                        parent.classList.add('form-container--error');
                        parent.classList.remove('form-container--success');
                    }
                } else if (isPostCode) {
                    control.value = control.value.replace(/[^0-9.]/g, '');
                    control.value = control.value.replace(/(\..*)\./g, '$1');
                    if (control.value.length === 5) {
                        parent.classList.remove('form-container--error');
                        parent.classList.add('form-container--success');
                        control.value = control.value.split(/(?=.{2}$)/).join(' ');
                    } else {
                        parent.classList.add('form-container--error');
                        parent.classList.remove('form-container--success');
                    }
                } else if (isTel) {
                    control.value = control.value.replace(/[^0-9.]/g, '');
                    control.value = control.value.replace(/(\..*)\./g, '$1');
                    let sk = false;
                    if (control.dataset.exception === 'sk') {
                        let parent = control.closest('.flex');
                        let select = parent.querySelector('select');
                        if (select.value === 'sk') {
                            sk = true;
                        }
                    }
                    if (control.value.length === 9 || (sk && control.value.length >= 9)) {
                        parent.classList.remove('form-container--error');
                        parent.classList.add('form-container--success');
                        control.value = control.value.split(/(?=.{3}$)/).join(' ');
                        control.value = control.value.split(/(?=.{7}$)/).join(' ');
                        control.value = control.value.split(/(?=.{11}$)/).join(' ');
                    } else {
                        parent.classList.add('form-container--error');
                        parent.classList.remove('form-container--success');
                    }
                } else {
                    parent.classList.remove('form-container--error');
                    parent.classList.add('form-container--success');
                }
            }
        }
    }

    static listenControl(control) {
        let onlyLetters = control.dataset.required === 'onlyLetters';

        control.addEventListener('input', (e) => {
            Form.validateControl(control);

            if (onlyLetters) {
                if (!(/^[a-zA-Zá-ž ]+$/).test(control.value)) {
                    control.value = control.value.slice(0, -1);
                }
            }
        });
    }

    static sliderMobile() {
        const priceSliderMobile = document.getElementById('priceSliderMobile');
        const priceFromMobile = document.getElementById('priceFromMobile');
        const priceToMobile = document.getElementById('priceToMobile');

        if (priceSliderMobile) {
            priceSliderMobile.noUiSlider = null;
        }

        if (priceSliderMobile && priceFromMobile && priceToMobile) {
            this.initSlider(priceSliderMobile, priceFromMobile, priceToMobile, 'priceFilterMobile');
        }
    }

    static sliderDesktop() {
        const priceSlider = document.getElementById('priceSlider');
        const priceFrom = document.getElementById('priceFrom');
        const priceTo = document.getElementById('priceTo');

        if (priceSlider) {
            priceSlider.noUiSlider = null;
        }

        if (priceSlider && priceFrom && priceTo) {
            this.initSlider(priceSlider, priceFrom, priceTo, 'priceFilter');
        }
    }

    static initSlider(priceSlider, priceFrom, priceTo, componentName) {
        const min = parseInt(priceSlider.dataset.min);
        let max = parseInt(priceSlider.dataset.max);
        if (min === max) {
            max += 1000;
        }
        noUiSlider.create(priceSlider, {
            start: [parseInt(priceFrom.value), parseInt(priceTo.value)],
            connect: true,
            range: {
                'min': min,
                'max': max
            }
        });
        priceSlider.noUiSlider.on('update', function (values, handle) {
            if (handle) {
                priceTo.value = parseInt(values[handle]);
            } else {
                priceFrom.value = parseInt(values[handle]);
            }
        });
        priceSlider.noUiSlider.on('change', function (values, handle) {
            naja.uiHandler.submitForm(document.querySelector('#frm-'+componentName+'-priceForm'));
        });
        priceFrom.addEventListener('input', () => {
            window.clearTimeout(priceFrom.dataset.timeout);
            priceFrom.dataset.timeout = setTimeout(function () {
                priceSlider.noUiSlider.set([priceFrom.value, null]);
                naja.uiHandler.submitForm(document.querySelector('#frm-'+componentName+'-priceForm'));
            }, 500);
        });
        priceTo.addEventListener('input', () => {
            window.clearTimeout(priceTo.dataset.timeout);
            priceTo.dataset.timeout = setTimeout(function () {
                priceSlider.noUiSlider.set([null, priceTo.value]);
                naja.uiHandler.submitForm(document.querySelector('#frm-'+componentName+'-priceForm'));
            }, 500);
        });
    }

    static handleChecked() {
        const triggers = document.querySelectorAll('input[data-checked]');

        if (triggers.length > 0) {
            triggers.forEach(trigger => {
                trigger.addEventListener('input', () => {
                    let el = trigger.dataset.checked;
                    let elSelector = document.querySelector(el);
                    if (elSelector) {
                        elSelector.classList.toggle('none');
                    }
                });
            });
        }
    }

    static handleFixedLabel() {
        const containers = document.querySelectorAll('.jsFormContainerFixedLabel');
        let activeClass = 'form-fixed-label--active';

        if (containers.length > 0) {
            containers.forEach(container => {
                let input = container.querySelector('.form-control');
                let label = container.querySelector('.form-fixed-label');

                if (input.value === '') {
                    label.classList.remove(activeClass);
                } else {
                    label.classList.add(activeClass);
                }

                input.addEventListener('input', () => {
                    if (input.value === '') {
                        label.classList.remove(activeClass);
                    } else {
                        label.classList.add(activeClass);
                    }
                });
            });
        }
    }

    static handleAddToBasket() {
        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--addedProduct' && event.detail.fromCache === false) {
                MicroModal.show('modalAddToBasket', {
                    awaitCloseAnimation: true
                });
            }
        });
    }

    static handleNewPasswordSetting() {
        const firstInput = document.getElementById('newPassword');
        const secondInput = document.getElementById('newPasswordControl');
        const message = document.getElementById('newPasswordError');

        if (firstInput && secondInput && message) {
            const button = firstInput.closest('form').querySelector('button[type="submit"]');

            const toggleMsg = () => {
                if (firstInput.value !== secondInput.value || (firstInput.value === '' && secondInput.value === '')) {
                    message.classList.remove('none');
                    button.setAttribute('disabled', '');
                } else {
                    message.classList.add('none');
                    button.removeAttribute('disabled');
                }
            };

            firstInput.addEventListener('input', toggleMsg);
            secondInput.addEventListener('input', toggleMsg);
        }
    }

    static handleRedirectSelect() {
        const selects = document.querySelectorAll('.js-redirect-select');

        if (selects.length > 0) {
            selects.forEach(select => {
                select.addEventListener('change', () => {
                    window.location.href = select.value;
                })
            });
        }
    }

    static handleOrderPerson() {
        const form = document.getElementById('frm-orderPersonForm-personForm');
        const emailInput = document.getElementById('emailOrderInput');

        const selectPersonAddress = document.getElementById('jsPersonAddress');
        if (!form || !selectPersonAddress) {
            return;
        }
        const selectPersonAddressUrl = selectPersonAddress.dataset.url;

        selectPersonAddress.addEventListener('change', () => {
            const url = selectPersonAddressUrl + '&orderPersonForm-id=' + selectPersonAddress.value;

            naja.makeRequest('GET', url, null, {
                history: false,
            })
                .then(payload => {
                    if (emailInput && payload.personEmail) {
                        emailInput.value = payload.personEmail;
                    }

                    const data = JSON.parse(payload.formDefaults);

                    for (let key in data.person_detail) {
                        let el = form.querySelector('[name="person_detail[' + key + ']"]');
                        if (el) {
                            el.value = data.person_detail[key];
                        }
                    }

                    for (let key in data.address) {
                        let el = form.querySelector('[name="address[' + key + ']"]');
                        if (el) {
                            el.value = data.address[key];
                        }
                    }
                });
        });

        const selectDeliveryPersonAddress = document.getElementById('jsDeliveryPersonAddress');
        if (!selectDeliveryPersonAddress) {
            return;
        }

        const selectDeliveryPersonAddressUrl = selectDeliveryPersonAddress.dataset.url;

        selectDeliveryPersonAddress.addEventListener('change', () => {
            const url = selectDeliveryPersonAddressUrl + '&orderPersonForm-id=' + selectDeliveryPersonAddress.value + '&delivery=1';

            naja.makeRequest('GET', url, null, {
                history: false,
            })
                .then(payload => {
                    const data = JSON.parse(payload.formDefaults);

                    for (let key in data.person_detail) {
                        let el = form.querySelector('[name="delivery_person_detail[' + key + ']"]');
                        if (el) {
                            el.value = data.person_detail[key];
                            const container = el.closest('.form-container');
                            const label = container && container.querySelector('label');
                            if (label) label.classList.add('form-fixed-label--active');
                        }
                    }

                    for (let key in data.address) {
                        let el = form.querySelector('[name="delivery_address[' + key + ']"]');
                        if (el) {
                            el.value = data.address[key];
                            const container = el.closest('.form-container');
                            const label = container && container.querySelector('label');
                            if (label) label.classList.add('form-fixed-label--active');
                        }
                    }
                });
        });
    }
}
